export default __webpack_public_path__ + "static/media/iOS.8c4986ee.svg";